import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RangeSliderElementDirective } from '@df/ui/form/range-slider/range-slider-element.directive';
import { RangeSliderHandleDirective } from '@df/ui/form/range-slider/range-slider-handle.directive';
import { RangeSliderLabelDirective } from '@df/ui/form/range-slider/range-slider-label.directive';
import { RangeSliderComponent } from '@df/ui/form/range-slider/range-slider.component';
import { RangeTooltipWrapperComponent } from '@df/ui/form/range-slider/range-tooltip-wrapper.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
        RangeSliderComponent,
        RangeSliderElementDirective,
        RangeSliderHandleDirective,
        RangeSliderLabelDirective,
        RangeTooltipWrapperComponent
    ],
    exports: [RangeSliderComponent]
})
export class RangeSliderModule {}
